import { getInternalNotePlainText } from "./whatsappTextFormat";

const escapeRegex = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const normalizeAuthorNames = (authorNames) => {
  const list = Array.isArray(authorNames) ? authorNames : [authorNames];
  return [
    ...new Set(
      list
        .filter(Boolean)
        .map((n) => String(n).trim())
        .filter((n) => n.length >= 2 && n.toLowerCase() !== "você" && n.toLowerCase() !== "voce")
    ),
  ];
};

/**
 * Prefixo WhatsApp de operador: *Nome*: texto (preferência incluir_nome).
 * Usado só em mensagens ao cliente; anotações internas não devem persistir/exibir isso.
 */
export function buildOperatorNamePrefix(operatorName) {
  const name = operatorName != null ? String(operatorName).trim() : "";
  if (!name) return "";
  return `*${name}*: `;
}

/**
 * Remove prefixo *Nome*: / <strong>Nome</strong>: do início quando o autor já aparece no cabeçalho da anotação.
 */
export function stripOperatorNamePrefix(text, authorNames) {
  if (text == null || typeof text !== "string") return "";
  const raw = String(text);
  const names = normalizeAuthorNames(authorNames);
  if (!names.length) return raw;

  const plain = getInternalNotePlainText(raw);

  for (const name of names) {
    const esc = escapeRegex(name);
    const plainPrefixPatterns = [
      new RegExp(`^\\s*\\*${esc}:\\*\\s*`, "i"),
      new RegExp(`^\\s*(?:\\*{1,2})?${esc}(?:\\*{1,2})?\\s*:\\s*`, "i"),
      new RegExp(`^\\s*${esc}\\s*:\\s*`, "i"),
    ];
    const matchedPlain = plainPrefixPatterns.find((re) => re.test(plain));
    if (!matchedPlain) continue;

    const htmlPatterns = [
      new RegExp(`^\\s*<(?:strong|b)[^>]*>\\s*${esc}\\s*:\\s*</(?:strong|b)>\\s*`, "i"),
      new RegExp(`^\\s*<(?:strong|b)[^>]*>\\s*${esc}\\s*</(?:strong|b)>\\s*:\\s*`, "i"),
      new RegExp(`^\\s*\\*${esc}:\\*\\s*`, "i"),
      new RegExp(`^\\s*\\*${esc}\\*\\s*:\\s*`, "i"),
      new RegExp(`^\\s*\\*${esc}\\s*:\\s*\\*\\s*`, "i"),
      matchedPlain,
    ];

    for (const re of htmlPatterns) {
      if (re.test(raw)) return raw.replace(re, "");
    }

    return plain.replace(matchedPlain, "");
  }

  return raw;
}

/** Aplica prefixo de nome apenas para envio a canais de cliente (não anotação interna). */
export function applyOperatorNamePrefixForClientMessage(text, { incluirNome, operatorName }) {
  const body = text != null ? String(text) : "";
  if (!body.trim()) return body;
  if (Number(incluirNome) !== 1) return body;
  const name = operatorName != null ? String(operatorName).trim() : "";
  if (!name) return body;
  const prefix = buildOperatorNamePrefix(name);
  const plain = getInternalNotePlainText(body);
  const esc = escapeRegex(name);
  if (
    new RegExp(`^\\s*\\*${esc}:\\*\\s*`, "i").test(plain) ||
    new RegExp(`^\\s*(?:\\*{1,2})?${esc}(?:\\*{1,2})?\\s*:\\s*`, "i").test(plain)
  ) {
    return body;
  }
  return `${prefix}${body}`;
}
